import { createContext, useContext, useEffect, useState } from "react";
import axios from "../api/axios";

axios.defaults.withCredentials = true; // Para enviar cookies en cada petición

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [cargando, setCargando] = useState(true);

  // Verificar sesión con el backend
  const verificarSesion = async () => {
    try {
      const res = await axios.get("/api/verify");
      if (res.data?.user) {
        setUser(res.data.user);
        localStorage.setItem("user", JSON.stringify(res.data.user));
      } else {
        setUser(null);
        localStorage.removeItem("user");
      }
    } catch (err) {
      setUser(null);
      localStorage.removeItem("user");
    } finally {
      setCargando(false);
    }
  };

  // Cargar usuario desde localStorage y verificar con backend
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    verificarSesion();
  }, []);

  // Login: guarda en estado y localStorage
  const login = (userData) => {
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
  };

  // Logout: limpia todo
  const logout = async () => {
    try {
      await axios.post("/api/logout");
    } catch (err) {
      console.error("Error cerrando sesión:", err);
    } finally {
      setUser(null);
      localStorage.removeItem("user");
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, cargando }}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook para usar el contexto
export const useAuth = () => useContext(AuthContext);
